// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'user_nickname',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'shop',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'order_detail',
    label: '',
    Object: 'value',
    width: '430'
  }, {
    prop: 'delivery_detail',
    label: '',
    Object: 'value',
    width: '430'
  }, {
    prop: 'status',
    back: true,
    label: '',
    Object: 'value',
    width: '120'
  }],
  orderViewItem: [{
    prop: 'status',
    back: true
  }, {
    prop: 'type'
  }, {
    prop: 'delivery_order'
  }, {
    prop: 'created_at',
    date: true,
    format: ['YYYY年mm月dd日 HH:MM', 'YYYY-mm-dd HH:MM']
  }, {
    prop: 'shop'
  }, {
    prop: 'payment_channel'
  }, {
    prop: 'paid_at',
    date: true,
    format: ['YYYY年mm月dd日 HH:MM', 'YYYY-mm-dd HH:MM']
  }, {
    prop: 'remarks'
  }, {
    prop: 'admin_remarks'
  }, {
    prop: 'payment_remarks'
  }, {
    prop: 'sale_order_number'
  }, {
    prop: 'so_invoice_date'
  }],
  CustomerViewItem: [{
    prop: 'customer_name'
  }, {
    prop: 'contact_number'
  }, {
    prop: 'customer_id'
  }, {
    prop: 'nickname'
  }, {
    prop: 'email'
  }],
  billingAddrViewItem: [{
    prop: 'email',
  }, {
    prop: 'receiver_name'
  }, {
    prop: 'detail_address',
  }, {
    prop: 'receiver_phone_number'
  }],
  giftMsgViewItem: [
    {
      prop: 'personalized_message_recipient'
    },
    {
      prop: 'personalized_message_giver'
    },
    {
      prop: 'personalized_message_content'
    }
  ],
  deliveryAddrViewItem: [{
    prop: 'email',
  }, {
    prop: 'receiver_name'
  }, {
    prop: 'detail_address',
  }, {
    prop: 'receiver_phone_number'
  }],
  logisticViewItem: [{
    prop: 'delivery_service'
  }, {
    prop: 'tracking_number'
  }],
  exchangeRateViewItem: [{
    prop: 'usd_sgd_exchange_rate'
  }, {
    prop: 'inquiry_time'
  }, {
    prop: 'usd_gst_amount'
  }, {
    prop: 'sgd_gst_amount'
  }],
  collectionViewItem: [{
    prop: 'collection_time'
  }, {
    prop: 'receiver_name'
  }, {
    prop: 'detail_address'
  }, {
    prop: 'receiver_phone_number'
  }],
  tableDataViewItem: [{
    prop: 'image',
    img: true,
    label: '',
    width: '50'
  }, {
    prop: 'shop_item',
    label: '',
    Object: 'value'
    // width: '100'
  }, {
    prop: 'shop_item_stock',
    label: '',
    Object: 'value'
    // width: '100'
  }, {
    prop: 'is_a_gift',
    label: '',
    Object: 'value'
    // width: '40'
  }, {
    prop: 'sku',
    label: '',
    Object: 'value'
    // width: '40'
  }, {
    prop: 'count',
    label: '',
    // width: '40',
    Object: 'value'
  }, {
    prop: 'price',
    label: '',
    Object: 'value'
    // width: '40'
  }, {
    prop: 'status',
    back: true,
    label: '',
    Object: 'value',
    width: '40'
  }],
  host_information: [{
    prop: 'host_name'
  }, {
    prop: 'phone_number'
  }, {
    prop: 'host_id'
  }],
}
